export default {};

(() => {
  const rootWindow = window.parent || window;
  const viewportMeta = rootWindow.document.querySelector(
    'meta[name="viewport"]'
  );

  if (viewportMeta) {
    viewportMeta.content = "width=device-width, initial-scale=1.0";
  } else {
    rootWindow.document.head.insertAdjacentHTML(
      "afterbegin",
      `
      <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    `
    );
  }

  // move focus to main content
  const skipLink = document.querySelector(".skipnav > .nav-link");
  if (skipLink) {
    skipLink.addEventListener("click", (event) => {
      event.preventDefault();
      event.target.blur();
      // Store hash
      const hash = "#main-content";

      document.querySelector(hash).focus();
      window.location.hash = "";

      const mainContentContainer = document.getElementById("main-content");
      if (mainContentContainer) {
        mainContentContainer.scrollIntoView();
      }
    });
  }
})();
